var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM11.3766 6.02597L15.6104 6C15.8182 6 16 6.18182 16 6.38961L15.974 10.6234C15.974 10.8312 15.8182 10.987 15.6104 10.987H14.7532C14.5455 10.987 14.3636 10.8312 14.3636 10.6234L14.4416 8.7013L14.3896 8.64935L7.14286 15.8961C7.09091 15.9481 6.98701 16 6.93506 16C6.85714 16 6.75325 15.9481 6.7013 15.8961L6.1039 15.2987C6.05195 15.2468 6 15.1429 6 15.0649C6 15.013 6.05195 14.9091 6.1039 14.8571L13.3506 7.61039L13.2987 7.55844L11.3766 7.63636C11.1688 7.63636 11.013 7.45455 11.013 7.24675V6.38961C11.013 6.18182 11.1688 6.02597 11.3766 6.02597Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.9e56eed2be32149666721ae0b8e8606f.svg";
export { ForwardRef as ReactComponent };